var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weight-600 address-box text-center"},[_c('div',[_vm._v("\n        "+_vm._s(_vm.practiceDetails.Address1)+"\n    ")]),_vm._v(" "),_c('div',[_vm._v("\n        "+_vm._s(_vm.practiceDetails.City)+" "+_vm._s(_vm.practiceDetails.State)+" "+_vm._s(_vm.practiceDetails.Zip)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ee6092","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientPracticeAddress.vue
// module id = null
// module chunks = 